import classNames from "classnames";

export interface CarouselGeneric {
    children: React.ReactNode,
    className?: string;
}

const CarouselGeneric = (props:CarouselGeneric) => {
    
    return (<div className={
        classNames(
            'flex overflow-x-auto flex-nowrap space-x-4 -mr-4 lg:mr-0 ',
            props.className
        )
    }>
        {props.children}
    </div>)
}

export default CarouselGeneric;